import palette from '../palette';

const MuiFilledInput = {
  styleOverrides: {
    root: {
      '& > svg': {
        fill: palette.text.primary,
        right: 24,
      },
      ':after': {
        border: 'none',
      },
      borderRadius: 0,
    },
  },
};

export default MuiFilledInput;
